module.exports = __webpack_public_path__ + "media/src/img/payment/heart-icon-e5e73ba516096624760791903e5cd3c2.svg";